<template>
  <div>
    <div class="valign-wrapper section">
      <span style="padding: 0px 5px 0px 0px">
        <a v-on:click.prevent="toCoursesVue()">
          <a class="waves-effect waves-light btn-flat btn-small indigo lighten-5">Курсы</a>
        </a>
      </span>
    </div>

    <br />
    <a class="indigo-text text-lighten-1">Курс {{course.name}}</a>

    <Loader v-if="loading" />
    <div v-else>

      <h6>Занятия по курсу:</h6>

      <div class="row">
        <div class="col s12 m8 l6">
          <table>
            <tbody>
              <tr v-for="(idModeOrVideo,index) of process" v-bind:key="index">
                <td>
                    
                  <a v-if="index === doNow[2]" class="indigo-text text-darken-2 fontbold">
                    Рекомендуемое сейчас занятие
                    <br />
                  </a>

                  <a
                    class="grey-text text-darken-3"
                  >{{index+1}}. {{getNameVideoOrModeById(idModeOrVideo)}}</a>

                  <div v-if="idModeOrVideo.startsWith('v')">
                    <div class="valign-wrapper section">
                      <span style="padding: 0px 65px 0px 0px">
                        <a
                          v-on:click.prevent="setVideo(idModeOrVideo)"
                          class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
                        >Смотреть</a>
                      </span>

                      <span style="padding: 0px 0px 0px 0px">
                        <label>
                          <input
                            type="checkbox"
                            v-bind:id="idModeOrVideo"
                            v-bind:value="idModeOrVideo"
                            v-model="viewedVideos"
                            v-on:change="setVideoViewed(idModeOrVideo)"
                          />

                          <span>
                            <a class="indigo-text text-lighten-1">пройдено</a>
                          </span>
                        </label>
                      </span>
                    </div>
                  </div>

                  <div v-else class="row">
                    <div class="col s12 m12 l12">
                      <table>
                        <tbody>
                          <tr class="tr-not-border">
                            <td>{{idModes0Names[0]}}</td>
                            <td>{{getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[0])+'%'}}</td>
                            <td>
                              <a
                                v-if="getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[0])>=erSatzLevel*100"
                                class="indigo-text"
                              >
                                <i class="material-icons teal-text text-lighten-1">check_circle_outline</i>
                              </a>
                            </td>
                            <td>
                              <a
                                v-on:click.prevent="setModeRegime(idModeOrVideo, idModes0[0])"
                                class="waves-effect waves-light btn-flat btn-small"
                                v-bind:class="(idModeOrVideo === doNow[0] && idModes0[0]=== doNow[1]) ? `indigo white-text fontbold` :`indigo lighten-5`"
                              >Делать</a>
                            </td>
                          </tr>

                          <tr class="tr-not-border">
                            <td>{{idModes0Names[1]}}</td>
                            <td>{{getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[1])+'%'}}</td>
                            <td>
                              <a
                                v-if="getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[1])>=erSatzLevel*100"
                                class="indigo-text"
                              >
                                <i class="material-icons indigo-text">check_circle_outline</i>
                              </a>
                            </td>
                            <td>
                              <a
                                v-on:click.prevent="setModeRegime(idModeOrVideo, idModes0[1])"
                                class="waves-effect waves-light btn-flat btn-small"
                                v-bind:class="(idModeOrVideo === doNow[0] && idModes0[1]=== doNow[1]) ? `indigo white-text fontbold` :`indigo lighten-5`"
                              >Делать</a>
                            </td>
                          </tr>

                          <tr class="tr-not-border">
                            <td>{{idModes0Names[2]}}</td>
                            <td>{{getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[2])+'%'}}</td>
                            <td>
                              <a
                                v-if="getErSatzPercentByIdModeAndIdMode0(idModeOrVideo,idModes0[2])>=erSatzLevel*100"
                                class="indigo-text"
                              >
                                <i class="material-icons indigo-text">check_circle_outline</i>
                              </a>
                            </td>
                            <td>
                              <a
                                v-on:click.prevent="setModeRegime(idModeOrVideo, idModes0[2])"
                                class="waves-effect waves-light btn-flat btn-small"
                                v-bind:class="(idModeOrVideo === doNow[0] && idModes0[2]=== doNow[1]) ? `indigo white-text fontbold` :`indigo lighten-5`"
                              >Делать</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
              
              <br>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.fontbold {
  font-weight: bold;
}

.fontbig {
  font-size: 150%;
}

.tr-not-border {
  border-bottom: 0px;
}

.row { 
  margin-bottom: 2px;    
}

td {
  padding: 5px 1px;
}

.section {
  padding-top: 0;
  padding-bottom: 0;
}
</style>


<script>
import VideosMixin from "@/utils/videos.mixin.js";
import VideoMixin from "@/utils/video.mixin.js";
import ModesMixin from "@/utils/modes.mixin.js";

export default {
  name: "course",
  mixins: [VideosMixin, VideoMixin, ModesMixin],
  data: () => ({
    loading: false
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    course() {
      return this.$store.getters.course;
    },
    process() {
      return this.course.process;
    },
    doNow() {
      return this.$store.getters.doNow;
    }
  },
  async mounted() {
    await this.updateProgressModes();
    this.updateDoNow();
  },

  methods: {
    toCoursesVue() {
      this.$router.push("/");
    },
    getNameVideoOrModeById(idModeOrVideo) {
      let videoOrMode;
      if (idModeOrVideo) {
        if (idModeOrVideo.startsWith("v")) {
          videoOrMode = this.videos.find(video => {
            return video.id === idModeOrVideo;
          });
          return videoOrMode ? "Видеоурок: " + videoOrMode.name : "";
        } else {
          videoOrMode = this.modes.find(mode => {
            return mode.id === idModeOrVideo;
          });
          return videoOrMode ? "Упражнение: " + videoOrMode.name : "";
        }
      }
    },
    updateDoNow() {
      let progressModeRegime;
      let doNow = [];
      for (const [index, idModeOrVideo] of this.process.entries()) {
        if (idModeOrVideo.startsWith("v")) {
          // это idVideo
          if (
            !this.viewedVideos ||
            !this.viewedVideos.includes(idModeOrVideo)
          ) {
            doNow[0] = idModeOrVideo;
            doNow[1] = null;
            doNow[2] = index;
            this.$store.commit("setDoNow", doNow);
            return;
          }
        } else {
          // это idVMode
          for (let idMode0 of this.idModes0) {
            progressModeRegime = this.progressModes.find(element => {
              return (
                element.idMode == idModeOrVideo && element.idMode0 == idMode0
              );
            });
            if (progressModeRegime.erSatz < this.erSatzLevel) {
              doNow[0] = idModeOrVideo;
              doNow[1] = idMode0;
              doNow[2] = index;
              this.$store.commit("setDoNow", doNow);
              return;
            }
          }
        }
      }
    }
  },
  components: {}
};
</script>
